<template>
    <b-container class="m-3">
        <b-row>
            <b-col>
                <p class="h4">
                    <strong>Recommended Reviews</strong>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-alert show dismissible>
                    <div>
                        <b-icon icon="info-circle"></b-icon>
                        <span class="p-2"><strong>Your trust is our top concern</strong>, so businesses can't pay to alter or remove their reviews. <b-link href="https://trust.gozhere.com">Learn more.</b-link></span>
                    </div>
                </b-alert>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-input-group>
                    <b-form-input v-model="searchText" placeholder="Search within reviews"></b-form-input>
                    <b-input-group-prepend>
                        <span class="input-group-text">
                            <b-icon icon="search"></b-icon>
                        </span>
                    </b-input-group-prepend>
                </b-input-group>
            </b-col>
            <b-col cols="3">
                <b-form-select v-model="selected" :options="options"></b-form-select>
            </b-col>
        </b-row>
        <b-row class="py-3">
            <b-col>
                <b-card>
                    <b-container>
                        <b-row>
                            <b-col align-self="center">
                                <b-container>
                                    <b-row>
                                        <b-col cols="3">
                                            <b-img src="https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png"
                                                height="60" 
                                            />
                                        </b-col>
                                        <b-col>
                                            <b-row>
                                                <strong>Username</strong>
                                            </b-row>
                                            <b-row>
                                                Location
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </b-col>
                            <b-col>
                                <!--
                                    make this similar to yelp's hovering changing colors
                                    -->
                                <b-row class="py-2">
                                    <Star
                                        ref="star"
                                        :fontScale=2
                                        :readOnly=false
                                    /> 
                                </b-row>
                                <b-row class="py-2">
                                    <b-link @click="addReview">
                                        Start your review of Tim Ho Wan.
                                    </b-link>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="d-flex justify-content-center mb-3" v-if="reviews_retrieving == true">
            <!--
                TODO
                Replace spinner with skeleton
            -->
            <b-spinner type="grow" label="Loading..." variant="primary"></b-spinner>
        </b-row>
        <b-row>
            <Review v-for="review in reviews_list" :key="review.id" 
                :shortenedName="review.user.firstName + ' ' + review.user.lastName.charAt(0)"
                :profilePic="review.user.profileImg"
                :user_numFriends=0
                :user_numReviews=0
                :user_numPhotos=0
                :city="review.user.city"
                :dateOfReview="review.created"
                :numPhotos="review.photos.length"
                :text="review.text"
                :numReactionUseful=0
                :numReactionFunny=0
                :numReactionCool=0
                :photos="review.photos"
            />
        </b-row>
        <b-row>
            <b-pagination
                v-if="showPagination"
                v-model="reviews_currentPage"
                :total-rows="reviews_totalRows"
                :per-page="reviews_perPage"
                :hide-ellipsis=true
                limit=7
            ></b-pagination>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
import Review from './Review'
import Star from '../place/Star'

export default {
    components: {
        Review,
        Star
    },
    data() {
        return {
            searchText:'',
            selected: 'A',
            options: [
                { value: 'A', text: 'Newest First' },
                { value: 'B', text: 'Oldest First' },
                { value: 'C', text: 'Highest Rated' },
                { value: 'D', text: 'Lowest Rated' },
            ],
            showPagination: true
        }
    },
    computed: {
        reviews_retrieving: {
            get() {
                return this.$store.state.reviews_retrieving
            }
        },
        reviews_list: {
            get() {
                return this.$store.state.reviews_list
            }
        },
        reviews_currentPage: {
            get() {
                return this.$store.state.reviews_currentPage
            },
            set(newValue) {
                this.$store.dispatch('reviews_setCurrentPage', newValue)
                this.$store.dispatch('retrieveReviews')
            }
        },
        reviews_totalRows: {
            get() {
                return this.$store.state.reviews_totalRows
            }
        },
        reviews_perPage: {
            get() {
                return this.$store.state.reviews_perPage
            }
        }
    },
    methods: {
        // duplicate on CTAs.vue
        addReview() {
            console.log('addReview clicked')
            history.pushState(
                {},
                null,
                this.$route.path + '/addreview'
            )
            this.$router.push({
                name: 'AddReview',
                params: {}
            })
        }
    },
    mounted() {
        console.log('mounted')
        var placeId = this.$route.params.id
        console.log('placeId1: ',placeId)
        this.$store.dispatch('setPlaceId', placeId)
        this.$store.dispatch('retrieveReviews')
    }
}
</script>